module.exports = __webpack_public_path__ + "static/media/doc.d51ec5f9.svg";